import React, { useState, useEffect } from "react";
import { Card, Button, Form, Table, Rate, Layout, notification, Select, Descriptions, Radio, Col } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { ResponseFeedback } from "../../graphql/feedback";
import { DeliveredProcedureOutlined } from "@ant-design/icons";
import { fmtDateTime } from "../../common/Utils";
import { UserLink } from "../../components/UserLink/UserLink";
import { FeedbackSider } from "./FeedbackSider";
import "./Feedback.scss";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";
import { RegionFilterBar } from "../../components/filter/RegionFilterBar";
import { useHistory, useLocation } from "react-router";
import { Toolbar } from "../../components/Toolbar";
import { SortOrder } from "antd/lib/table/interface";

export const Feedbacks = observer(() => {
  const store = Store.feedbacks;
  const [curItem, setCurItem] = useState<any>(null);
  const [hideSider, setHideSider] = useState(true);

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    store.sortedInfo = sorter;
    store.refresh();
  };

  const onTab = (resolved) => {
    const query = new URLSearchParams({ resolved });
    history.push({
      search: query.toString(),
    });
  };

  const onUpdate = (it) => {
    setCurItem(it);
    store.refresh();
  };

  const [responseFeedback] = useMutation(ResponseFeedback);
  const onResolved = (r) => {
    responseFeedback({
      variables: { input: { id: r?.id, resolved: "1" } },
    }).then((res) => {
      store.refresh();

      notification.info({ message: "Success!" });

      if (curItem && curItem.userId === r.userId && curItem.createDate === r.createDate) {
        setCurItem(null);
        setHideSider(true);
      }
    });
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "User",
      key: "firstName",
      width: 160,
      sorter: true,
      render: (_, r) => r.user && <UserLink name={r.user.name} userId={r.user.id} />,
      sortOrder: store.sortedInfo.columnKey === "firstName" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Community",
      key: "Community",
      width: 160,
      render: (_, r) =>
        r.communities
          .map((x) => x.name)
          .sort()
          .join(", "),
    },
    {
      title: "Feedback Time",
      dataIndex: "createDate",
      sorter: true,
      key: "createDate",
      width: 160,
      render: (v) => fmtDateTime(v),
      sortOrder: store.sortedInfo.columnKey === "createDate" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "App Rating",
      dataIndex: "star",
      key: "star",
      sorter: true,
      width: 120,
      render: (v) => <Rate disabled value={v} style={{ fontSize: "12px" }}></Rate>,
      sortOrder: store.sortedInfo.columnKey === "star" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Feedback Title",
      dataIndex: "title",
      width: 160,
      key: "title",
    },
    {
      title: "Feedback Content",
      dataIndex: "content",
      key: "content",
    },
  ];

  const columns2 = [
    ...columns,
    {
      title: "Close Case",
      key: "opt",
      width: 100,
      render: (_, r) => (
        <Button
          type="link"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onResolved(r);
          }}
          icon={<DeliveredProcedureOutlined />}
        />
      ),
    },
  ];

  const onRow = (r, i) => {
    setHideSider(false);
    setCurItem(r);
  };

  return (
    <Layout className="feedback-page">
      <Layout.Content className="padding24" style={{ marginRight: hideSider ? 0 : 400 }}>
        <Toolbar>
          <Radio.Group size="large" value={store.filter.resolved} onChange={(e) => onTab(e.target.value)}>
            <Radio.Button value={false}>Unresolved</Radio.Button>
            <Radio.Button value={true}>Resolved</Radio.Button>
          </Radio.Group>
        </Toolbar>
        <RegionFilterBar store={store} actionsSpan={8}>
          <Col span={8}>
            <Form.Item label="App Rating">
              <Select style={{ width: "50%" }} value={store.filter.rating} onChange={(e) => (store.filter.rating = e)}>
                {store.ratings.map((x: any) => (
                  <Select.Option value={x.id} key={x.id}>
                    {x.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </RegionFilterBar>
        <Card size="small">
          <Descriptions title="Summary">
            <Descriptions.Item label="Number of Feedback"> {store.data.total || 0} </Descriptions.Item>
            <Descriptions.Item label="Average Rating"> {(store.data.avgRating || 0).toFixed(1)} </Descriptions.Item>
            <Descriptions.Item label="Average Response Time"> </Descriptions.Item>
          </Descriptions>
          <Table
            size="small"
            onChange={onChange}
            pagination={{ ...store.pagination, onChange: onPage }}
            loading={store.loading}
            rowKey={(r) => r.userId + r.createDate}
            columns={store.filter.resolved ? columns : columns2}
            dataSource={store.data.items}
            onRow={(r, i) => ({
              onClick: (e) => onRow(r, i),
            })}
          />
        </Card>
      </Layout.Content>
      <FeedbackSider onUpdate={onUpdate} curItem={curItem} visible={!hideSider} onClose={() => setHideSider(true)} />
    </Layout>
  );
});
